import axiosInstance from './AxiosInstance';

class ReportService {

  constructor() {
    this.endpoint = "/api/reports"
  }

  async getReport(data) {
    try {
      const response = await axiosInstance.post(`${this.endpoint}`, data);
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }

  async getApplicationReport(applicationID) {

    try {
      const response = await axiosInstance.get(`${this.endpoint}/application/${applicationID}`,{
        responseType: 'blob', // Ensure that the response is treated as a Blob
    });
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      throw error;
    }
  }
}

const reportService = new ReportService();

export { reportService };